import axios from 'axios';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    index() {
        return axios.$get('admin/settings');
    },

    update(vuexContext, { tag, settings }) {
        return axios.$put(`admin/settings/${tag}`, { settings });
    }
};
